<template>
    <v-form
            ref="modifyWarningForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="of-y">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{warning.id ? 'Edit Warning' : 'Create Warning'}}
                </div>
                <div v-if="!warning.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="pb-1">
                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Warning Name"
                            hide-details="auto"
                            v-model="warning.name"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull, duplicateWarningName]"
                            :error-messages="warningNameErrorMessages"
                    />
                </div>

                <div class="flex-grow-1 px-2 pb-1 " v-if="warning.document && viewValue">

                    <div class="pb-1 caption grey--text text--darken-2 pt-3">
                        Warning Document
                    </div>

                    <div class="d-flex align-center justify-space-around">
                        <v-btn
                                color="primary"
                                small
                                :loading="fetchingWarning"
                                :disabled="fetchingWarning"
                                @click="downloadDocument()"
                        >
                            Preview Warning Document
                        </v-btn>
                        <v-btn
                                color="primary"
                                small
                                @click="viewValue = false"
                        >
                            Upload New Warning Document
                        </v-btn>
                    </div>


                </div>

                <div class="flex-grow-1 of-y px-2 pb-1" v-else>
                    <v-file-input
                            label="PDF Warning Template"
                            hide-details="auto"
                            v-model="warningFile"
                            @change="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                </div>

                <div class="flex-grow-1 d-flex flex-column of-y pb-1 of-y" style="max-height: 400px">
                    <div style="position: sticky; top: 0; z-index: 9" class="px-2 white">
                        <div class="caption grey--text text--darken-2 pt-3">
                            Warning Offenses
                        </div>
                        <div slot="header" class="px-2 py-2">
                            <v-btn
                                    small
                                    block
                                    color="primary"
                                    @click="addOffence"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Add Offence
                            </v-btn>
                        </div>
                    </div>

                    <div class="pt-1 px-3">

                        <template v-for="(offence, n) in warning.config.offenses || []">
                            <div class="align-center d-flex my-6" :key="n">
                                <div>
                                    <v-btn
                                        x-large
                                        icon
                                        elevation="5"
                                        class="primary white--text ma-2"
                                    >{{n + 1}}</v-btn>
                                </div>

                                <div>

                                    <v-text-field
                                        dense
                                        outlined
                                        class="flex-grow-1 flex-equal mx-1 mt-2"
                                        label="Offence Charge Description"
                                        hide-details="auto"
                                        v-model="offence.name"
                                        @input="changesMade = true"
                                        :rules="[validationRules.required, validationRules.notNull]"
                                        :error-messages="warningNameErrorMessages"
                                    />
                                    <v-text-field
                                        dense
                                        outlined
                                        class="flex-grow-1 flex-equal mx-1 mt-2"
                                        label="Offence Corrective Action Description"
                                        hide-details="auto"
                                        v-model="offence.corrective"
                                        @input="changesMade = true"
                                        :rules="[validationRules.required, validationRules.notNull]"
                                    />
                                    <div class="d-flex align-center justify-center">
                                        <v-autocomplete
                                            dense
                                            outlined
                                            class="flex-grow-1 flex-equal mx-1 mt-2"
                                            label="Pre Sign Status"
                                            hide-details="auto"
                                            v-model="offence.before"
                                            @input="changesMade = true"
                                            :rules="[validationRules.required]"
                                            :items="empStatuses"
                                            item-text="name"
                                            item-value="id"
                                        />
                                        <v-autocomplete
                                            dense
                                            outlined
                                            class="flex-grow-1 flex-equal mx-1 mt-2"
                                            label="Post Sign Status"
                                            hide-details="auto"
                                            v-model="offence.after"
                                            @input="changesMade = true"
                                            :rules="[validationRules.required]"
                                            :items="empStatuses"
                                            item-text="name"
                                            item-value="id"
                                        />
                                    </div>
                                </div>



                                <div>
                                    <v-btn
                                        icon
                                        class="ma-2"
                                        color="error"
                                        @click="warning.config.offenses.splice(n, 1)"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </template>

                    </div>



                    <div
                            style="position: sticky; bottom: 0"
                            class="pa-1 text-center text-overline error--text white"
                            v-if="Array.isArray(warning.config.offenses) ? !warning.config.offenses.length : true"
                    >
                        A minimum of one offence is required
                    </div>
                </div>

                <div class="text-right pr-2 pb-1 pt-2">
                    <v-btn
                            @click="validateSave()"
                            fab
                            small
                            color="secondary"
                            :loading="loading"
                            :disabled="!changesMade || loading"
                    >
                        <v-icon v-if="!loading">mdi-content-save</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>

        <v-progress-linear
                v-if="showUpload"
                ref="upload"
                :value="uploadProgress"
                :indeterminate="showUpload && uploadProgress === null"
        ></v-progress-linear>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {arrSplice, generateRandomId, validationRules} from "@/core/codeFunctions";
import MultiSelectList from "@/components/General/Multi Select List/MultiSelectList";
import {newReqUpload} from "@/core/request";
import {Warning} from "@/core/store";
import {format} from "date-fns";

export default {
    components: {MultiSelectList},
    props: {
        editWarning: Object
    },
    data() {
        return {
            arrSplice,
            warning: new Warning(),
            warningNameErrorMessages: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false,
            warningFile: null,
            viewValue: true,
            selectedFarm: null,
            uploadProgress: null,
            showUpload: false,
            fetchingWarning: false
        }
    },
    watch: {
        editWarning: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                this.viewValue = true
                this.warning = new Warning(JSON.parse(JSON.stringify(val || null)))
            }
        },
        "warning.name"() {
            this.warningNameErrorMessages = null
        },
    },
    methods: {

        async downloadDocument() {
            try {
                this.fetchingWarning = true;
                await this.$newReqDownloadFile("POST",'setup/emp/getWarning', {id: this.warning.document}, `${this.warning.name}.pdf`)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.fetchingWarning = false
            }
        },

        addOffence() {
            this.warning.config.offenses.push({description: null, before: null, after: null})
        },

        duplicateWarningName(val) {
            if (!val) {
                return "A name is required"
            }
            if (this.warnings.find(warning => warning.id !== this.editWarning.id && this.warning.name === warning.name)) {
                return "Duplicate warning name"
            }
            return true
        },

        async validateSave() {

            if (!this.$refs.modifyWarningForm.validate())
                return false
            if (!this.warning.config.offenses.length) {
                return this.$snack.error("At least one offence is required")
            }


            if (this.warningFile) {
                try {
                    this.loading = true
                    const vm = this
                    this.showUpload = true;
                    const dbFile = await this.$newReqUpload(
                            "POST",
                            "setup/warning/uploadDoc",
                            this.warningFile,
                            "warning",
                            true,
                            (e) => {
                                const progress = Math.round((e.loaded / e.total) * 100)
                                vm.uploadProgress = progress >= 100 ? null : progress
                            }
                    )
                    this.warning.document = dbFile.id
                    this.showUpload = false;
                } catch (e) {
                    this.showUpload = false;
                    this.loading = false
                    return this.$snack.netWorkError()
                }
            }

            this.$emit('save', {warning: this.warning, ref: this})
        }
    },
    computed: {
        ...mapGetters(['warnings', 'farms', "empStatuses"])
    },
}
</script>

<style scoped>

</style>